import { URLS } from 'constants/url';

export interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: string;
}

export const NAV_ITEMS: Array<NavItem> = [
  {
    label: 'Finansial',
    href: URLS.FL_QUESTIONAIRE,
  },
  {
    label: 'UMKM',
    href: URLS.UMKM,
  },
  {
    label: 'Acara',
    href: URLS.EVENT,
  },
];
